<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <b-row>
              <b-col md="8">
                <h4><strong>{{ registTitle }} </strong></h4>
              </b-col>
              <b-col
                v-show="registButton === '업데이트'"
                md="4"
                class="text-right"
              >
                <b-button
                  size="md"
                  variant="warning"
                  @click="readOnly = false"
                >
                  <b>수정하기</b>
                </b-button>
              </b-col>
            </b-row>
          </div>
          <b-row>
            <b-col md="12">
              <b-form-group
                name="emailSet"
                label="이메일(Email)"
                label-for="email"
                :invalid-feedback="''"
                :valid-feedback="''"
              >
                <b-form-input
                  v-model="email"
                  v-validate.initial="veeEmail"
                  name="email"
                  :state="isValid('email')"
                  :readonly="emailFreezing"
                  placeholder="email"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row
            v-show="!emailChecked"
          >
            <b-col
              md="12"
              align-h="center"
              class="text-center"
            >
              <button
                class="btn btn-warning btn-md"
                :disabled="errors.has('email')|| !freezing"
                @click="getDetailInfo(0)"
              >
                이메일 등록 조회(Check Email if exists)
              </button>
              <br>
              <br>
            </b-col>
          </b-row>
          <b-row v-show="!freezing">
            <b-col md="6">
              <b-form-group
                name="password1Set"
                label="암호(Password)"
                label-for="password1"
                :invalid-feedback="'한글은 안됩니다!'"
                :valid-feedback="''"
              >
                <b-form-input
                  v-model="password1"
                  v-validate.initial="veePassword"
                  :type="'password'"
                  name="password1"
                  :state="isValid('password1')"
                  :disabled="freezing"
                  placeholder="암호"
                  @keypress="passwordKeypress"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                name="password2Set"
                label="암호재입력(Re-Password)"
                label-for="password2"
                :invalid-feedback="'암호 불일치!'"
                :valid-feedback="''"
              >
                <b-form-input
                  v-model="password2"
                  v-validate.initial="veePassword"
                  :type="'password'"
                  name="password2"
                  :state="password1 === ''? null : (password1 === password2)"
                  :disabled="freezing"
                  placeholder="암호재입력"
                  @keypress="passwordKeypress"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <remnant-basic
            ref="remnantBasic"
            :email="email"
            :read-only="readOnly"
          />
          <remnant-family
            ref="remnantFamily"
            :email="email"
            :read-only="readOnly"
          />
          <b-row>
            <b-col
              md="12"
            >
              <hr>
              <h4> 선택 정보(Optional) </h4>
              <hr>
            </b-col>
          </b-row>
          <remnant-training
            ref="remnantTraining"
            :email="email"
            :read-only="readOnly"
          />
          <b-row>
            <b-col
              v-show="!freezing"
              md="12"
            >
              <hr>
              <b-checkbox
                v-model="privacyChecked"
              >
                개인정보 활용에 동의 합니다. (Agree to personal information collection and usage agreement)
              </b-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              md="12"
              align-h="center"
              class="text-center"
            >
              <b-button
                v-show="!freezing"
                id="btnInsert"
                ref="btnInsert"
                class="my-5"
                :size="'md'"
                :variant="'success'"
                @click="validateUpdateDetailInfo()"
              >
                {{ registButton }}
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import api from '../api'
import RemnantBasic from './remnant/RemnantBasic'
import RemnantFamily from './remnant/RemnantFamily'
import RemnantTraining from './remnant/RemnantTraining'

export default {
  name: 'RemnantRegist',
  components: { RemnantBasic, RemnantFamily, RemnantTraining },
  data: function () {
    return {
      privacyChecked: false,
      registButton: '등록',
      registTitle: '장학생 신규 가입(장학생 신청자만 가입하세요!, Only for remnants)',
      emailChecked: false,
      editMode: 'regist',
      emailFreezing: false,
      readOnly: true,
      veePassword: {
        required: true,
        regex: /^([^가-힣]+)$/
      },
      email: '',
      veeEmail: {
        required: true,
        email: true
      },
      password1: '',
      password2: ''
    }
  },
  computed: {
    freezing () {
      return this.readOnly
    }
  },
  created () {
    // 로그인 한 경우
    if (this.$store.state.EMAIL !== '') {
      this.editMode = 'update'
      this.email = this.$store.state.EMAIL
      this.getDetailInfo(1)
    }
  },
  mounted () {
    // IECHECK
    if (window.document.documentMode) {
      alert("인터넷 익스플로러는 지원되지 않습니다. 크롬, 웨일, 사파리, 엣지 등을 사용해주세요 (Internet Explorer is not supported)")
      this.$router.push('/dashboard')
      return
    }
    this.$validator.reset()
  },
  methods: {
    isValid (name) {
      if (this.$validator.flags[name] === undefined) {
        return null
      } else if (!this.$validator.flags[name].validated) {
        return null
      } else {
        return this.$validator.flags[name].valid
      }
    },
    passwordKeypress (evt) {
      evt = (evt) || window.event
      var charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        // evt.preventDefault()
        return true
      } else {
        return true
      }
    },
    alertSuccess () {
      alert('등록 완료!')
      // XXX 메인으로 redirect
      // this.$router.go(this.$router.currentRoute)
    },
    alertFail (msg) {
      alert(msg)
    },
    alertRetryEmail () {
      alert('이메일을 다시 확인해 주세요!(Check the Email address)')
    },
    alertRetry () {
      alert('빨간색으로 표시된 상자를 확인해주세요.(Check all the red boxes)')
    },
    alertRetryPhoto () {
      alert('사진을 업로드 해주세요(Please upload a profile photo of yours)')
    },
    alertRetryBirth () {
      alert('생년월일 입력해주세요 (Please select your birthday)')
    },
    alertRetryFamily () {
      alert('가족사항을 입력해주세요 (Please write the information about your family)')
    },
    alertRetryPrivacy () {
      alert('개인정보 활용에 동의해주세요 (Please check personal information collection and usage agreement)')
    },
    alertFound () {
      if (this.editMode === 'update') {
        return
      }
      alert('이미 가입된 이메일입니다.(This Email is already used.)')
    },
    alertNotFound () {
      alert('등록된 정보가 없습니다! 등록을 진행해 주세요! (This Email can be used)')
      this.readOnly = false
      this.emailFreezing = true
    },
    clearInput (vueModel) {
      vueModel = ''
    },
    validateUpdateDetailInfo () {
      this.$validator.validate()
        .then(valid1 => {
          this.$refs.remnantBasic.$validator.validate()
            .then(valid2 => {
              this.$refs.remnantFamily.$validator.validate()
                .then(valid3 => {
                  this.updateDetailInfo(valid1 && valid2 && valid3)
                })
            })
        })
    },
    updateDetailInfo (valid) {
      if (!valid || this.password1 !== this.password2) {
        // 제대로 확인 하라고 에러 메시지
        this.alertRetry()
        return
      }
      // post arg 세팅
      var postArg = {}
      postArg['ERROR'] = ''
      postArg['email'] = this.email
      postArg['passwd'] = this.password1
      postArg['auth'] = -1
      postArg['updated'] = 1
      postArg = this.$refs.remnantBasic.exportData(postArg)
      postArg = this.$refs.remnantFamily.exportData(postArg)
      postArg = this.$refs.remnantTraining.exportData(postArg)
      if (postArg['ERROR'] === 'retry') {
        this.alertRetry()
        return
      } else if (postArg['ERROR'] === 'photo') {
        this.alertRetryPhoto()
        return
      } else if (postArg['ERROR'] === 'birth') {
        this.alertRetryBirth()
        return
      } else if (postArg['ERROR'] === 'family') {
        this.alertRetryFamily()
        return
      } else if (!this.privacyChecked) {
        this.alertRetryPrivacy()
        return
      }
      api.request('post', '/remnant/' + this.editMode, postArg)
        .then(response => {
          var data = response.data
          /* 200 이면  data에 바로 doc정보가 있거나, data.error가 있음
            400 이면 erros.response.data.error */
          if (data.error) {
            this.alertFail(data.error)
          } else {
            this.alertSuccess()
            /* TODO login 되어 있으면 수정해줘야함 */
            if (this.editMode === 'update') {
              this.$store.commit('setEmail', postArg.email)
              this.$store.commit('setName', postArg.nameKr)
              this.$store.commit('setUpdated', 1)
              this.$store.commit('setMobile', postArg.mobile)
              this.$store.commit('setProfile', postArg.photo)
              this.readOnly = true
              this.$validator.reset()
              this.$refs.remnantBasic.$validator.reset()
              this.$refs.remnantFamily.$validator.reset()
            } else {
              /* regist mode -> to dashboard */
              this.$router.push('/dashboard')
            }
          }
        })
        .catch(error => {
          this.alertFail(error.response.data.error)
        })
    },
    parseDetailInfo (data) {
      /* 내정보 불러옴 */
      this.emailFreezing = true
      this.registButton = '업데이트'
      this.registTitle = '나의 정보'
    },
    getDetailInfo (info) {
      if (this.errors.has('email')) {
        this.alertRetryEmail()
        return
      }
      api.request('get', '/remnant/check?' + 'email=' + this.email + '&info=' + info)
        .then(response => {
          var data = response.data
          if (data.error) {
            this.alertFail(data.error)
            return
          }
          if (data.check === 1 && info === 0) {
            // 이미 가입자
            this.alertFound()
          } else if (data.email) {
            // 로그인 후 정보수정으로 들어옴
            this.parseDetailInfo(data)
            this.emailChecked = true
            // email잠구자
          } else {
            // insert
            this.alertNotFound()
            this.emailChecked = true
          }
        })
      this.clearInput(this)
      this.$validator.reset()
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
